import { Component } from '@angular/core';
import {IonicPage, LoadingController, NavController, NavParams} from 'ionic-angular';
import {ApiProvider} from "../../providers/api/api";
import {ApiForumProvider} from "../../providers/api-forum/api-forum";
import {ChatStateProvider} from "../../providers/chat-state/chat-state";

/**
 * Generated class for the AppForumTopicResponsePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-forum-topic-response',
  templateUrl: 'app-forum-topic-response.html',
})
export class AppForumTopicResponsePage {

  topic: any;
  post: any;
  responseText: string;

  constructor(public navCtrl: NavController, public navParams: NavParams, public apiForm: ApiForumProvider, public loading: LoadingController, public chatState: ChatStateProvider) {
    this.topic = this.navParams.data.topic;
    this.post = this.navParams.data.post;
  }

  ionViewWillLoad() {
  }


  ionViewDidLoad() {
    console.log('ionViewDidLoad AppForumTopicResponsePage');

    if(this.post) {
      this.responseText = this.post.text;
    }
  }

  sendResponse() {
    console.log(this);
    if(!this.responseText) {
      return ;
    }

    let loader = this.loading.create();
    loader.present();

    this.apiForm.sendResponse(this.topic.id, this.responseText, this.post?this.post.id:'').then(_response => {
      this.chatState.incResponseCount();
      if(this.post) {
        this.post.text = this.responseText;
      } else {
        this.topic.posts.unshift(_response);
        this.topic.responseCount++;
      }
      this.navCtrl.pop();
      loader.dismissAll();
    });

  }

}



// WEBPACK FOOTER //
// ./src/pages/app-forum-topic-response/app-forum-topic-response.ts